const translations = {
    chargeCycles: 'charge cycles',
    flightHours: 'flight hours',
    flights: 'flights',
    oemDefault: 'OEM {{value}}',
    resetToDefault: 'Reset to default',
    unitCycles: 'Cycles',
    unitFlights: 'Flights',
    unitHours: 'Hours'
};

export default translations;
